import React, { useEffect, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import useAuthState from '@/states/auth.state';
import useTenantState from '@/states/tenant.state';

export const TenantProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { tenant_id } = useParams();
  const { tenants } = useAuthState();
  const { setCurrentTenant, setIsLoading } = useTenantState();

  useEffect(() => {
    if (!tenant_id) {
      setCurrentTenant(null);
      setIsLoading(false);
      return;
    }

    if (!tenants || tenants.length === 0) {
      setIsLoading(true);
      return;
    }

    const freshTenant = tenants.find(t => t.slug === tenant_id);

    if (freshTenant) {
      setCurrentTenant(freshTenant);
    } else {
      setCurrentTenant(null);
    }

    setIsLoading(false);
  }, [tenant_id, tenants, setCurrentTenant, setIsLoading]);

  return <>{children}</>;
};
